import React from 'react';
import { ArrowRight, Mail, Phone } from 'lucide-react';

const CTA: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary-600 to-primary-700">
      <div className="container-custom">
        <div className="text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Pronto para transformar sua empresa com Business Intelligence?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
            Junte-se a mais de 900 empresas que já estão usando a BD Analytics para tomar decisões estratégicas
            baseadas em dados e impulsionar o crescimento dos seus negócios.
          </p>

          {/* Estatísticas Rápidas */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-white mb-1">5M+</div>
              <div className="text-primary-200 text-sm">Pedidos Processados</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-white mb-1">R$ 1B+</div>
              <div className="text-primary-200 text-sm">Valor Analisado</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-white mb-1">900+</div>
              <div className="text-primary-200 text-sm">Usuários Ativos</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a 
              href="https://app.bdanalytics.com.br/auth/register" 
              className="btn-primary bg-white text-primary-600 hover:bg-gray-50 flex items-center justify-center group"
              target="_blank"
              rel="noopener noreferrer"
            >
              Começar a usar - 14 dias grátis
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Contato */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="flex items-center justify-center mb-4">
                <Mail size={24} className="text-primary-200" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Consultoria Especializada</h3>
              <p className="text-primary-200 text-sm mb-2">
                Nossa equipe de especialistas está pronta para ajudar
              </p>
              <a 
                href="https://wa.me/5511999999999?text=Olá! Gostaria de falar sobre consultoria especializada da BD Analytics" 
                className="text-primary-200 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Falar via WhatsApp
              </a>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-4">
                <Phone size={24} className="text-primary-200" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Suporte Técnico</h3>
              <p className="text-primary-200 text-sm mb-2">
                Suporte especializado para sua implementação
              </p>
              <a 
                href="https://wa.me/5511999999999?text=Olá! Preciso de suporte técnico da BD Analytics" 
                className="text-primary-200 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Falar via WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA; 